import gql from 'graphql-tag';

const FRAGMENT = gql`
    fragment LCProfile on lc_profile {
        id
        user_id
        bio
        highschool_info
        personal_info
        college_info
    }
    fragment User on users {
        id: user_id
        sub: user_cognito_sub
        fname: user_first_name
        lname: user_last_name
        gender_pronounce
        user_preferred_name
        user_phone
        type:user_type
        timezone
        state
    }
`;
export const GET_PROFILE = gql`
    query getUserProfile($id: Int!) {
        lc_profile(where: {user_id: { _eq: $id }}) {
            ...LCProfile
            user {
                ...User
            }
        }
    }
    ${FRAGMENT}
`;

export const UPDATE_PROFILE = gql`
    mutation update($id:Int, $input: lc_profile_set_input!) {
        update_lc_profile(where:{user_id:{_eq:$id}}, _set: $input) {
            returning {
                ...LCProfile
            }
        }
    }
    ${FRAGMENT}
`;
